import { loadingReducer } from './slice'

export const loading = loadingReducer

export default loadingReducer
